import { render, staticRenderFns } from "./MyOrderPage.vue?vue&type=template&id=165ee3f8&scoped=true&"
import script from "./MyOrderPage.vue?vue&type=script&lang=js&"
export * from "./MyOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ee3f8",
  null
  
)

export default component.exports